import $ from 'jquery'
import DateFilter from '@/components/date-filter';
import TicketCaisse from '@/components/caisse/ticket-caisse';
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import store_operation from "@/store/mods/caisse/operations"
import store_patient from "@/store/mods/clinique/patients"

export default {
    name: 'ticket-caisse',
    components: {
        DateFilter, TicketCaisse
    },
    props: [],
    data() {
        return {
            vm_state: open_menu_state,
            is_loading: true,
            is_empty: false,
            is_load_error: false,

            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',
            is_month: false,

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },

            fields: [
                { key: 'ref', label: 'Référence' }, 'patient', 'date',
                { key: 'action', label: 'Action.s' }
            ],

            patient_filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            total_pages: 0,

            paiement_data: {
                montant_du: '',
                montant_recu: '',
                montant_net_paye: '',
                reliquat_remis: '',
                reliquat: '',
                reste_a_payer: '',
                info_assurance: {
                    taux_couverture: '',
                    est_assure: '',
                    est_expire: '',
                    assurance_id: '',
                    assurance: '',
                    souscripteur_id: '',
                    souscripteur: '',
                    assure_principal_id: '',
                }
            },
            ticket_caisse_info: {},
            chosen_patient: {},
            caissiere: '',

            info_is_loading: true,
            info_error_load: false,
            sale_receipts: []
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: ""
            }
            this.is_month = true
            this.current_date_filter = data
            this.getListeTicketCaisse(data)
        },

        patient_filter() {
            if (this.patient_filter == '') {
                this.current_date_filter.patient = ''
                this.getListeTicketCaisse(this.current_date_filter)
            }
        } 
    },

    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        etat_ouverture_caisse() {
            return this.$store.getters['etat_ouverture_caisse'];
        },
    },

    mounted() {
        if (this.activeRole.nom == 'ROLE_CAISSIERE') {
            this.compte_id = 1 //  Caisse principale
        } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
            this.compte_id = 4 //  Caisse 1 (Infirmier)
        } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
            this.compte_id = 3 //  Comptabilité
        }

        this.checkRegisterCashStatus(this.compte_id)        // Function defined in util-mixins.js

        $(document).bind("click", function(e) {
            let $clicked = $(e.target);
            this.v = 0;
            if (!$clicked.parents().hasClass("option-container")) {
                $(".option-box").removeClass("animate-fadeInRight");
                $(".option-box").addClass("animate-fadeOutRight");
                $(".option-box").fadeOut();
            }
        });

        const filter_data = {
            compte_id: this.compte_id,
            user_id: this.userCredentials.user.id,
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: ""
        }
        this.current_date_filter = filter_data
        this.getListeTicketCaisse(filter_data)
    },

    methods: {
        /**
         * Open Menu Dropdown
         */
        openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        getListeTicketCaisse(data) {
            this.is_load_error = false
            this.is_loading = true
            store_operation.getListeTicketCaisse(data).then((receipts) => {
                this.sale_receipts = receipts.data
                this.total_pages = receipts.last_page

                if (this.sale_receipts.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }

                this.is_loading = false
            }).catch(() => {
                this.is_load_error = true
                this.is_loading = false
            })
        },

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.is_month = false

            this.getListeTicketCaisse(data)
        },

        groupPrestation(prestations) {
            Array.prototype.groupBy = function (key) {
                return this
                    .reduce((hash, obj) => {
                        if (obj[key] === undefined) return hash;
                        return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
                    }, {})
            };

            const tmp_grouped_operations = prestations.groupBy('data_type')
            let grouped_operations = []
          
            
            for (const key in tmp_grouped_operations) {
                // if (key == 'consommable_bon' || key == 'apport_social') {
                //     taux_couverture = ''
                // }
                const tmp_group = {
                    data_type: key,
                    taux_couverture: tmp_grouped_operations[key][0]['taux_couverture'],
                    libelle: this.setLibellePrestation(key),
                    prestations: tmp_grouped_operations[key]
                }
                grouped_operations.push(tmp_group)
            }

            this.paiement_data.remise = 0
            grouped_operations.forEach((group, index) => {
                let total_prix_by_group = 0
                let total_base_assurance_by_group = 0
                let total_pac_by_group = 0
                let total_part_assureur_by_group = 0
                let total_net_paye_by_group = 0
                let total_remise_by_group = 0
                let total_prix_vente_by_group = 0
                let group_taxe_specifique = 0
                group.prestations.forEach((prestation) => {
                    
                    let qte = 0
                    qte = prestation.qte

                    let pu = 0
                    if (this.can_set_pac && this.paiement_data.info_assurance.est_assure && prestation.data_type != 'consommable_bon') {
                        pu = prestation.prix_assure_clinique
                    } else {
                        pu = (prestation.prix_clinique > prestation.base_assurance)?prestation.prix_clinique:prestation.base_assurance
                    }
                    total_prix_by_group += (pu * qte)

                    total_net_paye_by_group += prestation.montant_paye

                    if (prestation.remise && prestation.remise > 0) {
                        total_remise_by_group += prestation.remise
                    }
                    
                    total_prix_vente_by_group += (prestation.data_type != 'apport_social')?prestation.montant_du:(-prestation.montant_du)
                    group_taxe_specifique += prestation.taxe_specifique

                    if (this.paiement_data.info_assurance.est_assure == 1) {
                        if (prestation.base_assurance > 0) {
                            total_base_assurance_by_group += (parseInt(prestation.base_assurance) * prestation.qte)
                        }

                        if (prestation.prix_assure_clinique > 0) {
                            total_pac_by_group += ( parseInt(prestation.prix_assure_clinique) * prestation.qte)
                        }
                        
                        total_part_assureur_by_group += prestation.part_assureur
                    }
                });
                grouped_operations[index].total_prix_by_group = total_prix_by_group
                grouped_operations[index].total_net_paye_by_group = total_net_paye_by_group
                grouped_operations[index].total_remise_by_group = total_remise_by_group
                grouped_operations[index].total_base_assurance_by_group = total_base_assurance_by_group
                grouped_operations[index].total_pac_by_group = total_pac_by_group
                grouped_operations[index].total_part_assureur_by_group = total_part_assureur_by_group
                grouped_operations[index].total_prix_vente_by_group = total_prix_vente_by_group
                grouped_operations[index].group_taxe_specifique = group_taxe_specifique

                this.paiement_data.remise += total_remise_by_group
            });
            

            return grouped_operations
        },

        getTicketReliquat(reliquat_id) {
            const data = {
                reliquat_id: reliquat_id
            }
            store_operation.getReliquatByID(data).then((response) => {
                if (response) {
                    this.paiement_data.montant_recu = response.montant_recu
                    this.paiement_data.reliquat_remis = response.reliquat_remis
                    this.paiement_data.reliquat = response.reliquat_reporte
                }
            });
        },

        async viewDetail(ticket) {
            this.info_is_loading = true
            await this.getTicketReliquat(ticket.reliquat_id)
            await store_patient.getPatientInsuranceInfo(ticket.patient_id).then((patient_insurance_info) => {
                const info_assurance = {
                    taux_couverture: '',
                    est_assure: patient_insurance_info.est_assure,
                    est_expire: patient_insurance_info.contrat_a_expire,
                    assurance_id: (patient_insurance_info.assur_id != null)?patient_insurance_info.assur_id:'',
                    assurance: patient_insurance_info.assur_nom,
                    souscripteur_id: (patient_insurance_info.souscripteur_id != null)?patient_insurance_info.souscripteur_id:'',
                    souscripteur: (patient_insurance_info.souscripteur != null)?patient_insurance_info.souscripteur:'',
                    assure_principal_id: (patient_insurance_info.assure_principal_id != null)?patient_insurance_info.assure_principal_id:'',
                }
                this.paiement_data.info_assurance = info_assurance

                this.ticket_caisse_info = {
                    reference: ticket.reference,
                    created_at: ticket.date
                }
    
                this.chosen_patient = {
                    nom: ticket.info_patient.patient,
                    prenoms: "",
                    age: ticket.info_patient.age,
                    sexe: ticket.info_patient.sexe,
                    telephone_mobile: ticket.info_patient.telephone
                }
    
                this.caissiere = ticket.caissiere

                let total_paye = 0
                let total_restant = 0
                let total_du = 0
                let total_taxe_specifique = 0
                ticket.prestations.forEach(prestation => {
                    if (prestation.montant_paye > 0) {
                        if (prestation.data_type != 'apport_social') {
                            total_paye += prestation.montant_paye
                        } else {
                            total_paye -= prestation.montant_paye
                        }
                    }

                    if (prestation.montant_restant > 0) {
                        total_restant += prestation.montant_restant
                    }

                    if (prestation.montant_du > 0) {
                        if (prestation.data_type != 'apport_social') {
                            total_du += prestation.montant_du
                        } else {
                            total_du -= prestation.montant_du
                        }
                        
                    }

                    total_taxe_specifique += prestation.taxe_specifique
                });
                this.paiement_data.montant_net_paye = (total_paye > 0)?total_paye:''
                this.paiement_data.montant_du = total_du
                this.paiement_data.reste_a_payer = total_restant
                this.paiement_data.total_taxe_specifique = total_taxe_specifique


                // if (Object.prototype.hasOwnProperty.call(ticket.transaction, 'montant_du')) {
                //     this.paiement_data.montant_recu = 0
                //     this.paiement_data.reliquat_remis = 0
                //     this.paiement_data.reliquat = 0
                //     // this.paiement_data.montant_recu = ticket.transaction.montant_recu
                //     // this.paiement_data.reliquat_remis = ticket.transaction.reliquat_remis
                //     // this.paiement_data.reliquat = ticket.transaction.reliquat_reporte
                // } else {
                //     this.paiement_data.montant_recu = total_du
                //     this.paiement_data.reliquat_remis = 0
                //     this.paiement_data.reliquat = 0
                // }

                this.paiement_data.grouped_prestations = this.groupPrestation(ticket.prestations)

                this.info_is_loading = false
                $('.ticket').modal('show')
            }).catch(() => {
                this.info_error_load = true
                this.info_is_loading = false
            })
        },

        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.current_date_filter.page = this.currentPage
                this.getListeTicketCaisse(this.current_date_filter)
            }
        },

        nextPage() {
            if (this.currentPage < this.total_pages) {
                this.currentPage++;
                this.current_date_filter.page = this.currentPage
                this.getListeTicketCaisse(this.current_date_filter)
            }
        },

        gotoPage(page) {
            if (page !== this.currentPage) {
                this.currentPage = page;
                this.current_date_filter.page = this.currentPage
                this.getListeTicketCaisse(this.current_date_filter)
            }
        },

        searchPatient() {
            this.current_date_filter.patient = this.patient_filter
            this.getListeTicketCaisse(this.current_date_filter)
        }
    }
}